/**
 * Shared Components - Barrel Export
 *
 * Central export file for all shared UI components.
 */

// Core UI Components
import Pagination from "./Pagination";
import StatsCard, { StatsContainer } from "./StatsCard";
import LoadingSpinner from "./LoadingSpinner";
import EmptyState from "./EmptyState";
import SectionHeader from "./SectionHeader";
import FilterBar, {
  SearchInput,
  StatusSelect,
  ResultsBadge,
} from "./FilterBar";
import {
  PrimaryButton,
  AccentButton,
  DangerButton,
  OutlineButton,
  GhostButton,
  SecondaryButton,
} from "./Button";
import WarningBox, { WarningList } from "./WarningBox";
import ConfirmationModal from "./ConfirmationModal";
import NotificationModal from "./NotificationModal";

// Form Components
import WalletSelector from "./WalletSelector";
import BulkPasteSelector from "./BulkPasteSelector";
import CurrencySelector from "./CurrencySelector";
import DistributionConfig, { DistributionSummary } from "./DistributionConfig";
import AirdropResult from "./AirdropResult";

// Export all
export {
  // Core UI
  Pagination,
  StatsCard,
  StatsContainer,
  LoadingSpinner,
  EmptyState,
  SectionHeader,
  FilterBar,
  SearchInput,
  StatusSelect,
  ResultsBadge,
  PrimaryButton,
  AccentButton,
  DangerButton,
  OutlineButton,
  GhostButton,
  SecondaryButton,
  WarningBox,
  WarningList,
  ConfirmationModal,
  NotificationModal,
  // Form Components
  WalletSelector,
  BulkPasteSelector,
  CurrencySelector,
  DistributionConfig,
  DistributionSummary,
  AirdropResult,
};
